import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/
// const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/videos/general view/", true, /[0-9]+\.mp4/)); }

const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

///[0-9]+\.mp4/
//const Gym = () => { return ImportHelper.importAll(require.context("../assets/videos/Gym/", true, /\.mp4/)); }
/*const BBQ = () => { return ImportHelper.importAll(require.context("../assets/videos/BBQ/", true, /\.mp4/)); }
const FirePit = () => { return ImportHelper.importAll(require.context("../assets/videos/Fire Pit/", true, /\.mp4/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/videos/Torre 1/", true, /\.mp4/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/videos/Torre 2/", true, /\.mp4/)); }
const ZonaEjercicios = () => { return ImportHelper.importAll(require.context("../assets/videos/Zona de Ejercicio/", true, /\.mp4/)); }
const ZonaJuegosInfantiles = () => { return ImportHelper.importAll(require.context("../assets/videos/Zona Juegos Infantiles/", true, /\.mp4/)); }
const CanchaDeTennis = () => { return ImportHelper.importAll(require.context("../assets/images/Cancha de Tennis/", true, /\.jpg/)); }
const ParquesInfantiles = () => { return ImportHelper.importAll(require.context("../assets/images/Parques Infantiles/", true, /\.jpg/)); }*/

export const ContextTransitions = {
    "General View": { initFrame:  130 },

    "Torre A Ovalada": { initFrame: 0 },
    "Torre B Ovalada": { initFrame: 0 },
    "Torre C Ovalada": { initFrame: 0 },
    "Torre D Ovalada": { initFrame: 0 },
    "Torre F Tira": { initFrame: 0 },
    "Torre G Tira": { initFrame: 0 },
    "Torre H Tira": { initFrame: 0 },
    "Torre I Tira": { initFrame: 0 },
    
    "Torre 1": { initFrame: 142 },
    "Torre 2": { initFrame: 10 },
    "Torre 3": { initFrame: 10 },
    "Torre 4": { initFrame: 10 },
    "Torre 5": { initFrame: 10 },
    "Pet Zone": { initFrame: 100 },
    "Gym": { initFrame: 35 },
    "Lobby": { initFrame: 0 },
    "Eco Terrace": { initFrame: 24 },
    "Solarium": { initFrame: 24 },
    "Infinity Pool": { initFrame: 24 },
    "Coworking": { initFrame:  114},
    "Yoga Deck": { initFrame:  114},
    "Children's Play": { initFrame:  114},
    "Jacuzzi View": { initFrame:  114},
    "Children's Pool": { initFrame: 0 },
    "BBQ": { initFrame: 0 },
    "Laundry": { initFrame: 94 },
    "Hall": { initFrame: 0 },
    "Gimnasio": { initFrame: 110 },

    "EveryTransition": { importTransition: AllTransitions }
}
